export const SUPER_ADMIN_LOGIN = "SUPER_ADMIN_LOGIN";

export const GET_SUPER_ADMIN_LOGIN_STATUS = "GET_SUPER_ADMIN_LOGIN_STATUS";

export const GET_SUPER_ADMIN_TOKEN = "GET_SUPER_ADMIN_TOKEN";




export const GET_SUPER_ADMIN_MENUS = "GET_SUPER_ADMIN_MENUS"; 